module.exports = __webpack_public_path__ + "static/media/logow.70b2de7c.png";